import { gql } from '@apollo/client';

export const GET_GRAPHQL_QUERY_ERROR = gql`
query getGraphQLQueryError {
    graphQLQueryError @client
}
`;
